const getSummeryPriceForActivitySeveralDays = (multiDates, summery) => {
  if (multiDates && multiDates.startDate && multiDates.endDate) {
    const diffDays = multiDates.endDate.diff(multiDates.startDate, 'days') + 1;
    return summery * diffDays;
  }

  return summery;
};



const getTotalPrice = (
  activity,
  dates,
  participants,
  addOns,
  mandatoryFees,
  relatedItems,
  currency,
  activityMultiDates
) => {
  let total = 0;

  

  participants.map(item => {
    if (!item.participants || !parseInt(item.participants)) return;
    
    

    if (
      (activity.relatedActivitiesForm || activity.isAccommodation) &&
      activity.pricesType === 'pricesDailyForm'
    ) {
      
      total += item[currency];
    } else if (activity.pricesType === 'futurePricesForm') {
      // Check if this participant is using fallback pricing (dates outside future price range)
      if (item.isFallbackPricing) {
        
        
        
        if (item.fallbackType === 'daily') {
          // Daily fallback: price is already calculated for the date range, don't multiply by nights
          
          total += item[currency];
        } else if (item.fallbackType === 'category') {
          // Category fallback: price per category * participants * nights
          if (dates && dates.startDate && dates.endDate) {
            const nights = dates.endDate.diff(dates.startDate, 'days');
            const calcTotal = parseFloat(item[currency]) * parseInt(item.participants) * nights;
            
            total += calcTotal;
          } else {
            total += parseFloat(item[currency]) * parseInt(item.participants);
          }
        } else if (item.fallbackType === 'fixed') {
          // Fixed fallback: price * nights
          if (dates && dates.startDate && dates.endDate) {
            const nights = dates.endDate.diff(dates.startDate, 'days');
            const calcTotal = parseFloat(item[currency]) * nights;
            
            total += calcTotal;
          } else {
            total += parseFloat(item[currency]);
          }
        } else {
         
          
          total += item[currency];
        }
      } else {
        // Standard future prices calculation
        const futureTotal = getTotalFuturePrices(dates, item[currency], currency);
        
        total += futureTotal;
      }
    } else if (
      activity.pricesType === 'pricesFixedForm' ||
      activity.pricesType === 'pricesCategoryForm'
    ) {
      if (dates && dates.startDate && dates.endDate) {
        const isParticipants = activity.pricesType === 'pricesCategoryForm';
        const fixedTotal = getTotalFixedPricesPerDay(
          dates,
          item[currency],
          item,
          isParticipants,
          activity.isAccommodation,
          activity.pricesType
        );
        
        total += fixedTotal;
      } else {
        
        total += parseFloat(item[currency]);
      }
    } else {
      const defaultTotal = item[currency] * parseInt(item.participants);
      
      total += defaultTotal;
    }
  });

 

  if (!activity.isAccommodation) {
    total = getSummeryPriceForActivitySeveralDays(activityMultiDates, total);
  }

  if (addOns) {
    addOns.map(item => {
      if (!item.value || !parseInt(item.value)) return;
      total += parseInt(item.value) * item[currency];
    });
  }

  if (mandatoryFees) {
    mandatoryFees.map(item => {
      if (!item[currency]) return;
      total += parseFloat(item[currency]);
    });
  }

  total += getTotalRelatedItems(
    relatedItems,
    currency,
    activity.isAccommodation
  );

  return parseFloat(total.toFixed(2));
};

const getTotalRelatedItems = (items, currency) => {
  let total = 0;

  items.map(item => {
    let itemTotal = 0;
    if (!item.participants) return;
    item.participants.map(participant => {
      if (!participant.participants || !parseInt(participant.participants))
        return;
      if (
        (item.accommodation || !item.scheduleType) &&
        item.pricesType === 'pricesDailyForm'
      ) {
        itemTotal += participant[currency];
      } else if (item.pricesType === 'futurePricesForm') {
        // Support fallback pricing for related items
        if (participant.isFallbackPricing) {
          if (participant.fallbackType === 'daily') {
            itemTotal += participant[currency];
          } else if (participant.fallbackType === 'category') {
             if (item.dates && item.dates.startDate && item.dates.endDate) {
              const nights = item.dates.endDate.diff(item.dates.startDate, 'days');
              itemTotal += parseFloat(participant[currency]) * parseInt(participant.participants) * nights;
            } else {
              itemTotal += parseFloat(participant[currency]) * parseInt(participant.participants);
            }
          } else if (participant.fallbackType === 'fixed') {
             if (item.dates && item.dates.startDate && item.dates.endDate) {
              const nights = item.dates.endDate.diff(item.dates.startDate, 'days');
              itemTotal += parseFloat(participant[currency]) * nights;
            } else {
              itemTotal += parseFloat(participant[currency]);
            }
          } else {
             itemTotal += participant[currency];
          }
        } else {
          itemTotal += getTotalFuturePrices(item.dates, participant[currency], currency);
        }
      } else if (
        item.pricesType === 'pricesFixedForm' ||
        item.pricesType === 'pricesCategoryForm'
      ) {
        if (item.dates && item.dates.startDate && item.dates.endDate) {
          const isParticipants = item.pricesType === 'pricesCategoryForm';
          itemTotal += getTotalFixedPricesPerDay(
            item.dates,
            participant[currency],
            participant,
            isParticipants,
            item.accommodation,
            item.pricesType
          );
        } else {
          itemTotal += parseFloat(participant[currency]);
        }
      } else {
        itemTotal += participant[currency] * parseInt(participant.participants);
      }
    });

    if (!item.isAccommodation) {
      total += getSummeryPriceForActivitySeveralDays(
        item.multiDates,
        itemTotal
      );
    } else {
      total += itemTotal;
    }

    if (!item.addOns) return;
    item.addOns.map(item => {
      if (!item.value || !parseInt(item.value)) return;
      total += parseInt(item.value) * item[currency];
    });

    if (!item.mandatoryFees) return;
    item.mandatoryFees.map(item => {
      if (!item[currency]) return;
      total += parseFloat(item[currency]);
    });
  });

  return parseFloat(total.toFixed(2));
};

const getTotalFixedPricesPerDay = (dates, price, item, isParticipants, isAccommodation, pricesTypes) => {
  const FIXED_PRICES = 'pricesFixedForm';
  const nights = dates.endDate.diff(dates.startDate, 'days');
  const participants = isParticipants ? item.participants : 1;
  if(isAccommodation != undefined && !isAccommodation && pricesTypes === FIXED_PRICES) // setting nights to 1 for fixed price activity
    return parseFloat(`${parseInt(1) * parseFloat(price) * participants}`);
  return parseFloat(`${parseInt(nights) * parseFloat(price) * participants}`);
};

const getTotalFuturePrices = (dates, price, currency) => {
  const nights =
    dates && dates.startDate && dates.endDate
      ? dates.endDate.diff(dates.startDate, 'days')
      : 1;
  return isNaN(nights) || isNaN(price) ? 0 : parseFloat(price) * nights;
};


export {
  getSummeryPriceForActivitySeveralDays,
  getTotalPrice,
  getTotalRelatedItems,
  getTotalFixedPricesPerDay,
  getTotalFuturePrices
};
